import React from 'react';
import styles from './AnalyticsCharts.module.scss';

interface TooltipPayloadItem {
  name?: string;
  value?: number;
  color?: string;
  payload?: { fullLabel?: string };
}

interface AnalyticsChartTooltipProps {
  active?: boolean;
  payload?: TooltipPayloadItem[];
  label?: string;
}

const AnalyticsChartTooltip: React.FC<AnalyticsChartTooltipProps> = ({
  active,
  payload,
  label,
}) => {
  if (!active || !payload?.length) return null;

  const fullLabel = payload[0]?.payload?.fullLabel ?? label;

  return (
    <div className={styles.tooltip}>
      <p className={styles.tooltipTitle}>{fullLabel}</p>
      {payload.map((entry) => (
        <p key={entry.name} className={styles.tooltipRow}>
          <span
            className={styles.tooltipDot}
            style={{ backgroundColor: entry.color }}
          />
          {entry.name}: {Number(entry.value).toLocaleString('es-AR')}
        </p>
      ))}
    </div>
  );
};

export default AnalyticsChartTooltip;
